import React from 'react';

const PlusIcon = () => {
  return (
    <svg
      className="btn-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 8"
      fill="none"
      role="img"
    >
      <title>More</title>
      <path d="M5.1 0.6C5.1 0.268629 4.83137 0 4.5 0C4.16863 0 3.9 0.268629 3.9 0.6V3.4H1.1C0.768629 3.4 0.5 3.66863 0.5 4C0.5 4.33137 0.768629 4.6 1.1 4.6L3.9 4.6V7.4C3.9 7.73137 4.16863 8 4.5 8C4.83137 8 5.1 7.73137 5.1 7.4V4.6L7.9 4.6C8.23137 4.6 8.5 4.33137 8.5 4C8.5 3.66863 8.23137 3.4 7.9 3.4H5.1V0.6Z" />
    </svg>
  );
};

export default PlusIcon;
